<script>
import Modal from '@/components/atoms/Modal.vue'
import { mapGetters } from 'vuex'
import { isOfferedSlotStart } from '@/modules/helpers/deliveryPeriodSlots'

export default {
    name: 'ModalDeliveryStateChange',
    components: {
        Modal,
    },
    computed: {
        ...mapGetters({
            currency: 'active/currency',
            deliveryTimeChanged: 'active/deliveryTimeChanged',
            deliveryFeeChanged: 'active/deliveryFeeChanged',
            deliveryFirstAvailable: 'deliveryFirstAvailable',
            deliveryPeriod: 'deliveryPeriod',
            orderRestaurant: 'order/restaurant',
            orderAsap: 'order/asap',
            orderTime: 'order/time',
        }),
        deliveryAddressDetails() {
            return this.$cart.calculation.delivery_address_details || {}
        },
        // escaped: the text is rendered with v-html
        restaurantName() {
            const name = this.orderRestaurant?.name || this.$cart.calculation.restaurant?.name || ''
            return name.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        },
        // the cart's ASAP range (DeliveryDetailsBlock asapTime), or null when ASAP cannot be offered
        asapRange() {
            const { min_delivery_time: min, max_delivery_time: max } = this.deliveryAddressDetails
            if (
                !this.deliveryPeriod?.immediate_available ||
                this.deliveryAddressDetails.restaurant_area_is_pre_order ||
                (!min && !max)
            )
                return null
            return `${max === min ? max : `${min}-${max}`} ${this.$t('base.minute')}`
        },
        // tasks#170: the option the cart ends up with. A scheduled window the cart adopted (a "moved" answer, or the
        // selected time is an offered window, e.g. after the switch away from an unavailable ASAP) is named in the cart's
        // label format; the ASAP range only when ASAP is selected and available; otherwise the earliest option offered
        earliestDeliveryTime() {
            if (
                !this.orderAsap &&
                this.orderTime &&
                (this.$cart.deliveryTimeAdjustment === 'moved' ||
                    isOfferedSlotStart(this.deliveryPeriod, this.orderTime))
            )
                return this.$options.filters.toDeliveryTime(this.orderTime)
            if (this.orderAsap && this.asapRange) return this.asapRange
            return this.$options.filters.toDeliveryTime(this.deliveryFirstAvailable)
        },
        isOpen: {
            get() {
                return this.deliveryTimeChanged || this.deliveryFeeChanged
            },
            set(isOpen) {
                this.$store.dispatch('active/setDeliveryTimeChange', isOpen)
                this.$store.dispatch('active/setDeliveryFeeChange', isOpen)
            },
        },
    },
    // tasks#170: lets the cart know the alert can tell a moved delivery time on this page (cartWatcher)
    mounted() {
        this.$cart.registerDeliveryTimeAlert(1)
    },
    beforeDestroy() {
        this.$cart.registerDeliveryTimeAlert(-1)
    },
    methods: {
        closeAlert() {
            this.$refs.alertModal.closeModal()
        },
    },
}
</script>

<template lang="pug">
modal(ref="alertModal" :closable="false" v-model="isOpen")
    template(v-slot:header)
        .modal-header-text
            template(v-if="deliveryTimeChanged && deliveryFeeChanged") {{ $t('cart.change_alert') }}
            template(v-else-if="deliveryTimeChanged && !deliveryFeeChanged") {{ $t('cart.change_alert_time') }}
            template(v-else-if="!deliveryTimeChanged && deliveryFeeChanged") {{ $t('cart.change_alert_fee') }}
    template(v-slot:body)
        p(v-if="deliveryFeeChanged" v-html="$t('cart.change_delivery_fee', {fee: $options.filters.toCurrency($cart.calculation.price_delivery, currency.locale,  currency.currency_code)})")
        p.mb-0(v-if="deliveryTimeChanged" v-html="$t('cart.change_delivery_time', {restaurant: restaurantName, time: earliestDeliveryTime})")
    template(v-slot:footer)
        button.btn.btn-primary(@click="closeAlert") {{$t('base.ok')}}
</template>
